import React from 'react'

import { Col, Row } from 'antd'
import Tarjeta from './Tarjeta'

import 'react-multi-carousel/lib/styles.css';

import '../../styles/grid-imagenes.css'

const GridImagenes = ({english}) => {

    const imagenes =[
        {
            imagen: 'Home/Fotos_proyectos/macrolotes-cabo-marques.jpg',
            imagenMovil: 'Home/Fotos_proyectos/JPEG/macrolotes-cabo-marques.jpg',
            titulo: 'Macrolotes',
            descripcion: 'Para desarrollo de Hoteles, Residencias, Departamentos y Centros Comerciales con vistas extraordinarias al Océano Pacífico.',
            enlace: '/proyectos/macrolotes'
        },
        {
            imagen: 'Home/Fotos_proyectos/los-riscos-cabo-marques.jpg',
            imagenMovil: 'Home/Fotos_proyectos/JPEG/los-riscos-cabo-marques.jpg',
            titulo: 'Los Riscos',
            descripcion: 'Fraccionamiento con 21 hectáreas desarrollado con un inquebrantable respecto con el medio ambiente.',
            enlace: '/proyectos/los-riscos'
        },
        {
            imagen: 'Home/Fotos_proyectos/banyan-tree-cabo-marques.jpg',
            imagenMovil: 'Home/Fotos_proyectos/JPEG/banyan-tree-cabo-marques.jpg',
            titulo: 'Banyan Tree',
            descripcion: 'El mejor hotel de clase mundial y restaurantes de la región al interior del desarrollo.',
            enlace: '/proyectos/banyan-tree'
        },
        {
            imagen: 'Home/Fotos_proyectos/marina-cabo-marques.jpg',
            imagenMovil: 'Home/Fotos_proyectos/JPEG/marina-cabo-marques.jpg',
            titulo: 'Marina Cabo Marqués',
            descripcion: 'La única marina en Acapulco Diamante.',
            enlace: '/proyectos/marina-cabo-marques'
        },
    ]

    const imagenesIngles =[
        {
            imagen: '/Home/Fotos_proyectos/macrolotes-cabo-marques.jpg',
            imagenMovil: '/Home/Fotos_proyectos/JPEG/macrolotes-cabo-marques.jpg',
            titulo: 'Macro lots',
            descripcion: 'DEVELOPMENT OPPORTUNIY FOR HOTELS, RESIDENCES, DEPARTMENTS AND SHOPPING CENTERS',
            enlace: '/projects/macro-lots'
        },
        {
            imagen: '/Home/Fotos_proyectos/los-riscos-cabo-marques.jpg',
            imagenMovil: '/Home/Fotos_proyectos/JPEG/los-riscos-cabo-marques.jpg',
            titulo: 'Los Riscos',
            descripcion: '21 HECTARES WITH UNBREAKABLE RESPECT FOR NATURE',
            enlace: '/projects/los-riscos'
        },
        {
            imagen: '/Home/Fotos_proyectos/banyan-tree-cabo-marques.jpg',
            imagenMovil: '/Home/Fotos_proyectos/JPEG/banyan-tree-cabo-marques.jpg',
            titulo: 'Banyan Tree',
            descripcion: 'FIVE DIAMOND HOTEL AND WORLD-CLASS RESTAURANTS',
            enlace: '/projects/banyan-tree'
        },
        {
            imagen: '/Home/Fotos_proyectos/marina-cabo-marques.jpg',
            imagenMovil: '/Home/Fotos_proyectos/JPEG/marina-cabo-marques.jpg',
            titulo: 'Marina Cabo Marques',
            descripcion: 'The only Marina in Acapulco Diamante',
            enlace: '/projects/marina-cabo-marques'
        },
    ]

    return (
        <div id="proyectos" className="grid-imagenes">
            <h2 style={{marginTop: 20}} className="titulo">{english ? 'Projects' : 'Proyectos'}</h2>
            <Row 
                justify="space-between"
                gutter={[0,20]}    
            >
                {english ?
                    imagenesIngles.map((imagen, index) => (
                        <Col xs={24} md={11} key={index}>
                            <Tarjeta imagen={imagen} english={true} />   
                        </Col>
                    ))   
                    :
                    imagenes.map((imagen, index) => (
                        <Col xs={24} md={11} key={index}>
                            <Tarjeta imagen={imagen} />   
                        </Col>
                    ))           
                }
            </Row>
        </div>
    )
}

export default GridImagenes